<template>
    <div class="animated fadeIn" v-if="info">
        <h1>Входящий звонок с номера {{ telenum }}</h1>
        <b-card>
            <template v-if="info.i_has_voucher_in_work">
                у меня есть заказы в работе <br>
                <a :href="$router.resolve({path:'/agent/voucher/'+info.voucher_to_open.id}).href">Открыть путевку</a>
            </template>
            <template v-else-if="info.i_has_order_in_work">
                у меня есть заявка  в работе<br>
                <a :href="$router.resolve({path:'/agent/order/'+info.order_to_open.id}).href">Открыть заявку</a>
            </template>
            <template v-else-if="info.other_has_voucher_in_work">
                у других есть заказы в работе<br>
            </template>
            <template v-else-if="info.i_has_voucher_finished">
                у меня есть заказы выполненные<br>
            </template>
            <template v-else-if="info.other_has_voucher_finished">
                у других есть заказы выполненные<br>
            </template>
            <template v-else-if="info.other_has_order_in_work">
                у других есть заявка в работе<br>
            </template>
            <template v-else-if="info.there_are_new_order">
                есть новая заявка
                <a :href="$router.resolve({path:'/agent/order/'+info.order_to_open.id}).href">Открыть заявку</a>
            </template>
            <template v-else>
                ничего не найдено
            </template>

            <div>
            <button class="btn btn-primary btn-sm btn-mg" @click.prevent="newOrder">Создать новую заявку</button>
            </div>

            <!--<template v-for="telenum in info.telenums">-->
                <!--{{ telenum }}<br>-->
            <!--</template>-->

            <table class="table table-bordered table-sm">
                <tr>
                    <th>#</th>
                    <th>Создано/Обработано</th>
                    <th>Заказчик</th>
                    <th>Агент</th>
                    <th>Заезд</th>
                    <th>Объект/Город</th>
                </tr>
                <template v-for="(elist, eclass) in info.owners">
                    <template v-if="eclass==='App\\Models\\Voucher'">
                        <tr v-for="voucher in elist">
                            <td>
                                <span class="nobr">
                                    <template v-if="canAccessVoucher(voucher)">
                                        <a :href="$router.resolve({ path:voucherPage(voucher.id)}).href">Путевка #{{voucher.id}}</a>
                                    </template>
                                    <template v-else>
                                        Путевка #{{voucher.id}}
                                    </template>
                                </span>
                                <br><small> {{ getVoucherStatusName(voucher.status_index) }}</small>
                            </td>
                            <td class="nobr">
                                <span v-html="printDateTime(voucher.date_create_iso, false, true)"></span><br>
                                <span v-html="printDateTime(voucher.status_changed_at, false, true)"></span>
                            </td>
                            <td>
                                {{voucher.contact_name}}<br>
                                <small>{{ voucher.comments_text }}</small>
                            </td>
                            <td>
                                <template v-if="voucher.user_id">
                                    {{voucher.user.surname}} {{voucher.user.name_}} {{voucher.user.patro}}
                                </template>
                                <br><small>{{voucher.user.login}} (#{{voucher.user.id}})</small>
                                <br><small>Агентство: #{{voucher.company_id}}</small>
                            </td>
                            <td class="nobr">
                                <template v-if="voucher.date_begin_iso && voucher.date_end_iso">
                                    {{ printDate(voucher.date_begin_iso) }}<br>
                                    {{ printDate(voucher.date_end_iso) }}
                                </template>
                            </td>
                            <td>
                                <template v-if="voucher.hotel">
                                    {{ voucher.hotel.title }} (#{{voucher.hotel.id}})
                                    <br><small>{{ voucher.city.title }} </small>
                                </template>
                            </td>
                        </tr>
                    </template>
                    <template v-if="eclass==='App\\Models\\Order'">
                        <tr v-for="order in elist">
                            <td class="nobr">
                                <template v-if="canAccessOrder(order)">
                                    <a :href="$router.resolve({ path:orderPage(order.id)}).href">Заявка #{{order.id}}</a>
                                </template>
                                <template v-else>
                                    Заявка #{{order.id}}
                                </template>
                                <br><small>{{ getOrderStatusTitle(order) }}</small>
                            </td>
                            <td class="nobr">
                                <span v-html="printDateTime(order.date_create_iso, false, true)"></span><br>
                                <span v-html="printDateTime(order.date_update_iso, false, true)"></span>
                            </td>
                            <td>
                                {{order.surname_correct}} {{order.name_correct}} {{order.patro_correct}}<br>
                                <small>{{ order.comments_text }}</small>
                            </td>
                            <td>
                                <template v-if="order.user_id">
                                    {{order.user.surname}} {{order.user.name_}} {{order.user.patro}}
                                </template>
                                <br><small>{{order.user.login}} (#{{order.user.id}})</small>
                                <br><small>Агентство: #{{order.company_id}}</small>
                            </td>
                            <td class="nobr">
                                <template v-if="order.date_begin_iso_correct && order.date_end_iso_correct">
                                    {{ printDate(order.date_begin_iso_correct) }}<br>
                                    {{ printDate(order.date_end_iso_correct) }}
                                </template>
                            </td>
                            <td>
                                <template v-if="order.hotel">
                                    {{ order.hotel.title }} (#{{order.t_obj_items_id_correct}})
                                    <br><small>{{ order.city.title }} </small>
                                </template>
                            </td>
                        </tr>
                    </template>
                </template>
            </table>

            <br/><hr/><hr/><br/>

            <!--{% for  in owners %}-->
            <!---->
            <!--{% if entityclass == "App\\Models\\Voucher" %}-->
            <!--<h1>Заказы</h1>-->
            <!--{% for voucher in entitylist %}-->
            <!--Заказ: {{ voucher.id }}<br>-->
            <!--Заказчик: {{ voucher.contact_name }} <br>-->
            <!--{%  if order.hotel_id %}-->
            <!--Объект размещения: {{ voucher.hotel.title }}/{{ voucher.city.title }}<br>-->
            <!--{%  endif %}-->

            <!--Менеджер: {{ voucher.user.surname }} {{ voucher.user.name_ }} {{ voucher.user.patro }} (# {{ voucher.user.id }})<br>-->

            <!--{% if not voucher.user.phone_stat is empty %}-->
            <!--Стационарный телефон менеджера: {{ voucher.user.phone_stat }} <br>-->
            <!--{% endif %}-->
            <!--{% if not voucher.user.phone_mobi is empty %}-->
            <!--Мобильный телефон менеджера: {{ voucher.user.phone_mobi   }} <br>-->
            <!--{% endif %}-->
            <!--{% if not voucher.user.local_phone_stat is empty %}-->
            <!--Внутренний телефон менеджера: {{ voucher.user.local_phone_stat }} <br>-->
            <!--{% endif %}-->

            <!--{% endfor %}-->
            <!--{% elseif entityclass == "App\\Models\\Order" %}-->
            <!--<h1>Заявки</h1>-->
            <!--{% for order in entitylist %}-->
            <!--{{ order }}-->
            <!--Заявка: {{ order.id }}<br>-->
            <!--Заказчик: {{ order.surname }} {{ order.name_ }} {{ order.patro }} <br>-->
            <!--{% if order.t_obj_items_id %}-->
            <!--Объект размещения: {{ order.hotel.title }}/{{ order.city.title }}<br>-->
            <!--{%  endif %}-->
            <!--{% if order.user_id %}-->
            <!--Менеджер: {{ order.user.surname }} {{ order.user.name_ }} {{ order.patro }}<br>-->
            <!--{% else %}-->
            <!--Менеджер не назначен-->
            <!--{% endif %}-->
            <!--{% endfor %}-->
            <!--{% endif %}-->


            <!--{% endfor %}-->

        </b-card>
    </div>
</template>

<script>

    import { functions } from '@/functions.js';
    import { functions_voucher } from '@/functions_voucher.js';
    import { functions_order } from '@/functions_order.js';
    import VueJsonPretty from 'vue-json-pretty'

    export default {
        name: 'NsbIncoming',
        mixins: [functions, functions_voucher, functions_order],
        components: {
            VueJsonPretty
        },
        data: function () {
            return {
                telenum: '',
                info: null
            }
        },
        methods: {
            newOrder: function () {
                this.createOrder(false, this.telenum)
            }
        },
        mounted: function() {
            this.telenum = this.$router.currentRoute.params.telenum;
            let t = this.telenum;
            t = t.substring(t.length - 10, t.length);

            this.httpPrepare();
            this.$http.get(this.apiurl('telephony/incoming/' + t)).then(function (response) {
                response = this.httpSuccess(response);
                console.log('incoming');
                console.log(response);
                console.log(response.payload);
                this.info = response.payload;
            }, this.httpError);
        },
    };
</script>

<style lang="scss"></style>
